import axios from "axios";
import getTokenFromCookies from "@/helpers/getTokenFromCookies";
const AuthService = {};

AuthService.signIn = async function (userData) {
  const { data } = await axios.post(
    `${axios.defaults.baseURL}/api/v1/auth/sign-in`,
    userData
  );

  return data;
};

AuthService.forgotPassword = async function (email) {
  const { data } = await axios.post(
    `${axios.defaults.baseURL}/api/v1/auth/forgot-password`,
    email
  );

  return data;
};

AuthService.logoutRequest = async function () {
  const headers = {
    Authorization: `Bearer ${getTokenFromCookies()}`,
  };
  const { data } = await axios.post(
    `${axios.defaults.baseURL}/api/v1/auth/logout`,
    null,
    { headers }
  );
  return data;
};

AuthService.resetPassword = async function (passwordData) {
  const headers = {
    Authorization: `Bearer ${getTokenFromCookies()}`,
  };

  const { data } = await axios.post(
    `${axios.defaults.baseURL}/api/v1/auth/reset-password`,
    passwordData,
    { headers }
  );

  return data;
};

export default AuthService;
